module.exports = __webpack_public_path__ + "img/permi.d090877.png";